import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import { Observable, finalize, tap } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private loaderService: LoaderService,
    private authService: AuthService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.authService.getLoginToken(); // Get token from sessionStorage

    // Check if loader should be disabled using custom header
    const disableLoader = req.headers.has('Disable-Loader');

    // Check if auth should be skipped (for external resources like GeoJSON)
    const skipAuth = req.headers.has('Skip-Auth');

    // Show loader if not disabled
    if (!disableLoader) {
      this.loaderService.show();
    }

    // Clone request to attach token if available and auth is not skipped
    let authReq = req;
    if (token && !skipAuth) {
      authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
        headers: req.headers.delete('Disable-Loader'), // Remove the custom header before making the request
      });
    } else {
      // Just remove custom headers without adding auth
      authReq = req.clone({
        headers: req.headers.delete('Disable-Loader').delete('Skip-Auth'),
      });
    }

    return next.handle(authReq).pipe(
      finalize(() => {
        if (!disableLoader) {
          this.loaderService.hide();
        }
      })
    );
  }
}
